import { render, staticRenderFns } from "./Lab.vue?vue&type=template&id=5e799c6b&scoped=true"
import script from "./Lab.vue?vue&type=script&lang=js"
export * from "./Lab.vue?vue&type=script&lang=js"
import style0 from "./Lab.vue?vue&type=style&index=0&id=5e799c6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e799c6b",
  null
  
)

export default component.exports